import React from "react";

const AlertCmponent = () =>{
    return(
        <section className=" flex flex-col  relative lg:px-0 py-10 lg:py-0 lg:max-h-[220px] bg-[#1F2A62] bg-cover lg:bg-no-repeat">
            {/* <div className="flex flex-col gap-4 lg:gap-0  relative lg:flex-row lg:py-[20px] "> */}
            <div className="lg:px-[68px] px-10">
            <div className="justify-center" style={{color:'white', justifyContent:'center', padding:'15px', fontSize:'17px'}}>
            <b>
            <sapn>
            In view of Section 397(3)(f) of Income Tax Act, 2025, TDS/TCS Correction Statements for FY 2018-19 (Qtr. 4), FY 2019-20 to 2022-23 (Qtr. 1 to Qtr. 4) and FY 2023-24 (Qtr. 1 to Qtr. 3) shall be accepted only up-to 31st March 2026. The same are time barred by limitation on 31.03.2026 and would not be accepted from 01.04.2026 onwards. Deductors, Collectors and other Stakeholders may kindly take note
 
            </sapn>
            <br></br>
            </b>
            </div>
            </div>
            {/* </div> */}
        </section>
    );
}

export default AlertCmponent;